const currentVersion = '1';

const closeStatuses = {
  none: 0,
  success: 1,
  delayed: 2,
  missingClient: 3,
  canceledByClient: 4,
  noTime: 5,
  noProblem: 6,
  noAccess: 7,
  needsBuild: 8,
  other: 9,
};

const ticketTypes = {
  breakdown: 1,
  technicalVisit: 36,
  qualityCheck: 70,
};

const skipClosingTicketTypes = [70];
const newInstallationTicketTypes = [10, 38];
const devicesValidationTicketTypes = [1, 2, 10, 11, 12, 14, 24, 32, 33, 38, 40, 43, 44, 68];

const ticketTypesCpeReturn = {
  ChangeTechnology: 68,
  InstalationMigration: 71,
};

const endTaskDialogInitialState = {
  open: false,
  taskId: null,
  isEnding: false,
  closeStatus: '',
  itsActivityType: '',
  itsActivityDescription: '',
  closeReason: '',
  closeNote: '',
  isTax: false,
  taxHours: 0,
  taxMinutes: 0,
  taxNote: '',
  imageInputData: [
    {
      source: 'openedBox',
      label: 'Кутия Отворена',
      required: true,
      value: null,
    },
    {
      source: 'plaza',
      label: 'Площадка',
      required: true,
      value: null,
    },
    {
      source: 'closedBox',
      label: 'Кутия Затворена',
      required: true,
      value: null,
    },
    {
      source: 'testWifi',
      label: 'Демонстрация/тест през W-Fi на наше устройство',
      required: true,
      value: null,
    },
    {
      source: 'testClientDevice',
      label: 'Демонстрация/тест през W-Fi на клиентско устройство',
      required: true,
      value: null,
    },
    {
      source: 'testCable',
      label: 'Демонстрация/тест през кабел',
      required: false,
      value: null,
    },
    {
      source: 'appartmentEntry',
      label: 'Влизане в апартамента',
      required: false,
      value: null,
    },
    {
      source: 'firstDeviceroute',
      label: 'Път до първото устройство',
      required: false,
      value: null,
    },
    {
      source: 'workingService',
      label: 'Работеща услуга',
      required: false,
      value: null,
    },
    {
      source: 'additionalDeviceOrService1',
      label: 'Допълнителни устройства/услуги',
      required: false,
      value: null,
    },
    {
      source: 'additionalDeviceOrService2',
      label: 'Допълнителни устройства/услуги',
      required: false,
      value: null,
    },
    {
      source: 'additionalDeviceOrService3',
      label: 'Допълнителни устройства/услуги',
      required: false,
      value: null,
    },
    {
      source: 'additionalDeviceOrService4',
      label: 'Допълнителни устройства/услуги',
      required: false,
      value: null,
    },
  ],
  videoSurvImageInputData: [
    {
      source: 'videoFile1',
      label: 'Файл от оглед 1',
      required: true,
      value: null,
    },
    {
      source: 'videoFile2',
      label: 'Файл от оглед 2',
      required: false,
      value: null,
    },
    {
      source: 'videoFile3',
      label: 'Файл от оглед 3',
      required: false,
      value: null,
    },
  ],
  breakdownCloseReason: null,
  serviceOnAddress: null,
};

export const errorMessages = {
  notOk: 'Възникна системна грешка',
};

export const closeTaskStyles = {
  requiredPaperContainer: {
    padding: '4px',
    margin: '3px',
    marginTop: '5px',
    backgroundColor: '#a5daff',
  },
  optionalPaperContainer: {
    padding: '4px',
    margin: '3px',
    marginTop: '5px',
    backgroundColor: '#a5daff',
  },
  margin: { margin: '4px' },
};

export {
  currentVersion,
  closeStatuses,
  ticketTypes,
  skipClosingTicketTypes,
  newInstallationTicketTypes,
  devicesValidationTicketTypes,
  endTaskDialogInitialState,
  ticketTypesCpeReturn,
};
